import { ROLES } from '../../config/roles';

export interface RouteAccessRule {
  key: string;
  path: string;
  roles: string[];
  permissions: string[];
  excludedRoles?: string[];
}

export const routeAccess = {
  dashboard: {
    key: 'dashboard',
    path: '/dashboard',
    roles: [ROLES.MANAGER, ROLES.ACCOUNTING],
    permissions: ['dashboard:view'],
    excludedRoles: [ROLES.SUPER_ADMIN, ROLES.AGENT],
  },
  weighing: {
    key: 'weighing',
    path: '/weighing',
    roles: [ROLES.MANAGER, ROLES.AGENT],
    permissions: ['weighing:create'],
    excludedRoles: [ROLES.SUPER_ADMIN],
  },
  tickets: {
    key: 'tickets',
    path: '/tickets',
    roles: [ROLES.MANAGER, ROLES.ACCOUNTING, ROLES.AGENT],
    permissions: ['ticket:view'],
    excludedRoles: [ROLES.SUPER_ADMIN],
  },
  reports: {
    key: 'reports',
    path: '/reports',
    roles: [ROLES.MANAGER, ROLES.ACCOUNTING],
    permissions: ['report:view', 'report:export'],
    excludedRoles: [ROLES.SUPER_ADMIN],
  },
  companies: {
    key: 'companies',
    path: '/companies',
    roles: [ROLES.SUPER_ADMIN],
    permissions: ['company:manage'],
    excludedRoles: [],
  },
  users: {
    key: 'users',
    path: '/users',
    roles: [ROLES.SUPER_ADMIN],
    permissions: ['user:manage'],
    excludedRoles: [],
  },
  configuration: {
    key: 'configuration',
    path: '/configuration',
    roles: [ROLES.MANAGER],
    permissions: ['settings:manage'],
    excludedRoles: [ROLES.SUPER_ADMIN],
  },
} as const satisfies Record<string, RouteAccessRule>;
